"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("VirtualScrollListToSelect", _vm._g(_vm._b({
    attrs: {
      "data-source": _vm.targetData
    },
    on: {
      change: _vm.handleChange
    },
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (index, name) {
      return {
        key: name,
        fn: function (data) {
          return [_vm._t(name, null, null, data)];
        }
      };
    }), _vm.showToolTip ? {
      key: "tooltipTitle",
      fn: function ({
        item
      }) {
        return [_vm._t("tooltipTitle", function () {
          return [_c("div", [_c("div", [_vm._v("店铺名称：" + _vm._s(item.shopName))]), item.platformName ? _c("div", [_vm._v("所属平台：" + _vm._s(item.platformName))]) : _vm._e()])];
        }, {
          item: item
        })];
      }
    } : null], null, true)
  }, "VirtualScrollListToSelect", _vm.$props, false), _vm.$listeners));
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;